import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export const PosNavigationRedesign = ProtoBaseModel.extend({
  featureEnabled: attr(Boolean)
});
export default ProtoBaseModel.extend({
  posNavigationRedesign: attr(PosNavigationRedesign)
});